import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'ui-components/components/checkbox';
import { ActionValueType } from './action-type';
import { messages } from './messages';
import styles from './styles.module.less';

export const Notifications = ({ notifications, onChange }) => {
  const updateNotifications = (notification, isChecked) => {
    const updatedNotifications = {
      ...notifications,
      [notification]: !isChecked,
    };
    onChange(updatedNotifications);
  };

  return (
    <div>
      <div className={styles['notifications-wrapper']}>
        {Object.entries(notifications).map(([notification, isChecked]) => {
          // Only render checkbox if message exists for this notification type
          const messageDescriptor = messages[notification];
          if (!messageDescriptor) {
            return null;
          }

          return (
            <Checkbox
              key={notification}
              checked={isChecked}
              label={<FormattedMessage {...messageDescriptor} />}
              onChange={() => updateNotifications(notification, isChecked)}
            />
          );
        })}
      </div>
    </div>
  );
};

Notifications.propTypes = {
  notifications: PropTypes.shape({
    [ActionValueType]: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
